import { Flex } from '@mantine/core';

import { ImporterStatus } from '@e-origin/shared';

import { anomaliesHandledIcon, anomaliesHSCodeOrDescriptionIcon, anomalyValueIcon, customsProcessingIcon, notSentIcon, releasedIcon } from '@assets';
import { IconBox } from '@components';

interface ForwarderStatusIndicatorProps {
  status: ImporterStatus;
}

export const ForwarderStatusIndicator: React.FC<ForwarderStatusIndicatorProps> = ({ status }) => {
  const statusIconMapper = new Map([
    [
      ImporterStatus.NEW,
      {
        icon: anomaliesHandledIcon,
        alt: 'NEW',
      },
    ],
    [
      ImporterStatus.IN_PROGRESS,
      {
        icon: customsProcessingIcon,
        alt: 'IN_PROGRESS',
      },
    ],
    [
      ImporterStatus.NOK,
      {
        icon: anomaliesHSCodeOrDescriptionIcon,
        alt: 'NOK',
      },
    ],
    [
      ImporterStatus.OK,
      {
        icon: releasedIcon,
        alt: 'OK',
      },
    ],
    [
      ImporterStatus.INVALID,
      {
        icon: anomalyValueIcon,
        alt: 'INVALID',
      },
    ],
    [
      ImporterStatus.EMPTY,
      {
        icon: notSentIcon,
        alt: 'EMPTY',
      },
    ],
  ]);

  const currentStatus = statusIconMapper.get(status);

  if (!currentStatus) {
    return null;
  }

  return (
    <Flex>
      <IconBox icon={currentStatus.icon} alt={currentStatus.alt} />
    </Flex>
  );
};
